import { SerializationHelper } from '../utils/SerializationHelper'
import { AbstractModel } from './AbstractModel'
import { CustomerRegister } from './CustomerRegister'
import { RallyRound } from './RallyRound'
import { User } from './User'
import { Vehicle } from './Vehicle'
import { Http } from '@/lib/utils/Http'

export class Team extends AbstractModel {
  id: number | null = null;
  name: string | null = null;
  description: string | null = null;
  logoId: number | null = null;
  logo: string | null = null;
  number: string | null = null;
  members: User[] = []
  rounds: RallyRound[] = []
  registrations: CustomerRegister[] = []
  headerImage: string | null = null;
  instagram: string | null = null;
  facebook: string | null = null;
  twitter: string | null = null;
  tiktok: string | null = null;
  blog: string | null = null;
  vehicles: Vehicle[] = [];
  charityId: number | null = null;
  rallyRoundId: number | null = null;

  static async getWithMembers (id: number) {
    const team = await this.get(id, [{ subclassInstance: Vehicle, subclassPath: 'vehicles' }])
    team.members = await User.getAllForTeam(id)
    return team
  }

  static async search (search: string) {
    const res = await Http.request(`/api/team/search-admin/${search}`)
    const teams = SerializationHelper.toInstanceArray(Team, await res.json())
    teams.map((team: Team) => {
      team.members = SerializationHelper.toInstanceArray(User, team.members)
      team.rounds = SerializationHelper.toInstanceArray(RallyRound, team.rounds)
    })
    return teams
  }
}
